import React from 'react'
import logo from '../images/logo-dark.webp'
import { NavLink } from 'react-router-dom';
export default function Navbar() {
  function searchApper() {
    if (document.querySelector('.search')?.classList.contains('d-none')) {
      console.log('hg');

      document.querySelector('.search')?.classList.remove('d-none')

    }
    else {
      document.querySelector('.search')?.classList.add('d-none')

    }


  }


  return <>
    <nav className="navbar navbar-expand-lg  bg-transparent navbar-dark mx-2 ">
      <div className="container-fluid ">
        <NavLink className="navbar-brand " to={'/'} ><img src={logo} className='w-100' alt="" /></NavLink>
        <button className="navbar-toggler" type="button" data-bs-toggle="collapse" data-bs-target="#navbarSupportedContent" aria-controls="navbarSupportedContent" aria-expanded="false" aria-label="Toggle navigation">
          <span className="navbar-toggler-icon"></span>
        </button>
        <div className="collapse navbar-collapse" id="navbarSupportedContent">
          <ul className="navbar-nav me-auto mb-2 mb-lg-0">
            <li className="nav-item">

              <NavLink to={'/'} className="nav-link  " aria-current="page"  >Home</NavLink>
            </li>
            <li className="nav-item">
              <NavLink to={'movies'} className="nav-link  " aria-current="page"  >movies</NavLink>
            </li>
            <li className="nav-item">
              <NavLink to={'tv'} className="nav-link  " aria-current="page"  >TvShow</NavLink>
            </li>
            <li className="nav-item">
              <NavLink to={'people'} className="nav-link  " aria-current="page"  >People</NavLink>
            </li>
          

          </ul>


          <div className='d-flex align-items-center me-2'>

            {/* <i className="fa-solid fa-magnifying-glass" onClick={searchApper}></i> */}

            <form className="d-flex" role="search">
              {/* <input className="form-control me-2  d-none search mx-2" type="search" placeholder="Search" aria-label="Search" /> */}
              <div className="icones mx-2  me-auto d-flex align-items-center  ">
                <a href="https://www.facebook.com/login/" target={'_blank'}>  <i className="fa-brands m-2 fa-facebook"></i></a>
                <a href="https://twitter.com/login" target={'_blank'} ><i className="fa-brands m-2 fa-twitter"></i></a>
                <a href="https://www.instagram.com/accounts/login/ " target={'_blank'}>  <i className="fa-brands m-2 fa-instagram"></i></a>
                <a href="https://accounts.spotify.com/en/login" target={'_blank'}>    <i className="fa-brands m-2 fa-spotify"></i></a>

              </div>
            </form>
          </div>
        </div>
      </div>
    </nav>
  </>

}
